import { Gauge } from "lucide-react";
import { RD_RING, RD_LABEL } from "./constants";

export const ReadinessRing = ({ r }) => {
  if (!r) return (
    <span data-testid="readiness-ring-loading" className="inline-flex h-9 w-9 animate-pulse items-center justify-center rounded-full bg-slate-100">
      <Gauge className="h-4 w-4 text-slate-300" />
    </span>
  );
  const color = RD_RING[r.status] || "#94a3b8";
  const pct = r.total ? r.ok / r.total : 0;
  const C = 2 * Math.PI * 9;
  return (
    <span data-testid={`readiness-ring-${r.status}`} title={`Trip readiness ${r.ok}/${r.total}`} aria-label={`Trip readiness ${r.ok} of ${r.total} — ${RD_LABEL[r.status]}`} className="relative inline-flex h-9 w-9 items-center justify-center">
      <svg viewBox="0 0 24 24" className="h-9 w-9 -rotate-90">
        <circle cx="12" cy="12" r="9" fill="none" stroke="#e2e8f0" strokeWidth="3" />
        <circle cx="12" cy="12" r="9" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeDasharray={C} strokeDashoffset={C * (1 - pct)} style={{ transition: "stroke-dashoffset 0.5s ease" }} />
      </svg>
      <span className="absolute text-[10px] font-bold leading-none" style={{ color }}>{r.ok}/{r.total}</span>
    </span>
  );
};
